import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";
import { animateScroll as scroll } from 'react-scroll';
import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");


function Users(props) {
  const { request } = useApi();
  const stateError = useError();
  const messages = message();

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - アカウント登録";
    scrollToTop();
  }, []);

  const handleSubmit = (user) => {
    request({
      method: "POST",
      url: `admin/accounts`,
      data: {
        name: user.accountName,
        desc: user.desc,
        contract_type: user.contractType,
        fh_user: user.fhUser,
        fh_password: user.fhPassword,
        max_words: user.maxWords,
        max_tweets: user.maxTweets,
        max_current: user.maxCurrent,
        max_users: user.maxUsers,
        max_groups: user.maxGroups,
        max_words_or: user.maxWordsOr,
        max_words_and: user.maxWordsAnd,
        max_words_not: user.maxWordsNot,
        // Add 2023.03.31 投稿分類
        max_noise_dicts: user.maxNoiseDicts,
        max_noise_words: user.maxNoiseWords,
        max_label_dicts: user.maxLabelDicts,
        max_label_words: user.maxLabelWords,
        max_labels: user.maxLabels,
        max_infos: user.maxInfos,
        max_procs: user.maxProcs,
        valid_from: user.validFrom,
        valid_until: user.validUntil,
        limit_release: user.limitRelease,
        master: user.master,
        dtm_config: {
          dtm_notice_id: user.dtmConfig.dtmNoticeId,
          locked: user.dtmConfig.locked,
        },
        options: {
          media: user.options.media,
          // Add 2023.03.31 投稿分類
          analysis: user.options.analysis,
        },
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/admin/account?success=create");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
        />
      }
    />
  );
}
export default withRouter(Users);
